module.exports = __webpack_public_path__ + "fonts/Stolzl-Light.17ef5b7.woff";